/**
 * Remix Icon money-dollar-circle-fill — Figma handoff for campaign card budget used.
 */
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon'

const DOLLAR_CIRCLE_PATH =
  'M6.00245 11C3.24102 11 1.00244 8.76143 1.00244 5.99998C1.00244 3.23858 3.24102 1 6.00245 1C8.76385 1 11.0025 3.23858 11.0025 5.99998C11.0025 8.76143 8.76385 11 6.00245 11ZM4.25244 6.99998V7.99998H5.50245V8.99998H6.50245V7.99998H7.00245C7.6928 7.99998 8.25245 7.44038 8.25245 6.74998C8.25245 6.05963 7.6928 5.49998 7.00245 5.49998H5.00245C4.86437 5.49998 4.75244 5.38808 4.75244 5.24998C4.75244 5.11193 4.86437 4.99997 5.00245 4.99997H7.75245V4H6.50245V3H5.50245V4H5.00245C4.31209 4 3.75244 4.55964 3.75244 5.24998C3.75244 5.94038 4.31209 6.49998 5.00245 6.49998H7.00245C7.1405 6.49998 7.25245 6.61193 7.25245 6.74998C7.25245 6.88808 7.1405 6.99998 7.00245 6.99998H4.25244Z'

export function CampaignBudgetUsedIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 12 12">
      <path d={DOLLAR_CIRCLE_PATH} />
    </SvgIcon>
  )
}
